/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Top_LeftInputs */

const en_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Top Left`)
};

const fr_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner en haut a gauche`)
};

const de_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position oben links`)
};

const it_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione in alto a sinistra`)
};

const ru_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция в верхнем левом углу`)
};

const es_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición superior izquierda`)
};

const zh_cn2_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置左上`)
};

const ja_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左上に配置する`)
};

const hi_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऊपरी बाएँ कोने में स्थित`)
};

const pt_pt2_shortcut_keys_name_cc_position_top_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Superior Esquerda`)
};

/**
* | output |
* | --- |
* | "Position Top Left" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Top_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_top_left = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Top_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cc_position_top_left(inputs)
	if (locale === "de") return de_shortcut_keys_name_cc_position_top_left(inputs)
	if (locale === "it") return it_shortcut_keys_name_cc_position_top_left(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cc_position_top_left(inputs)
	if (locale === "es") return es_shortcut_keys_name_cc_position_top_left(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cc_position_top_left(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cc_position_top_left(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cc_position_top_left(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cc_position_top_left(inputs)
	return en_shortcut_keys_name_cc_position_top_left(inputs)
});